import { render, staticRenderFns } from "./LanguageSwitcher.vue?vue&type=template&id=61fd93ac&scoped=true"
import script from "./LanguageSwitcher.vue?vue&type=script&lang=ts"
export * from "./LanguageSwitcher.vue?vue&type=script&lang=ts"
import style0 from "./LanguageSwitcher.vue?vue&type=style&index=0&id=61fd93ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fd93ac",
  null
  
)

export default component.exports